import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

// Goes to the URL the server already built for the chosen event (the option's
// data-url) — the controller decides nothing about routes.
export default class extends Controller {
  go() {
    const option = this.element.selectedOptions[0]
    if (option?.dataset.url) Turbo.visit(option.dataset.url)
  }
}
